import React from "react";
import { useI18n } from "@/context/I18nContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Languages } from "lucide-react";

const LABELS: Record<string, string> = { en: "English", es: "Español" };

export const LanguageSwitcher: React.FC<{ compact?: boolean }> = ({ compact }) => {
  const { locale, supported, setLocale, t } = useI18n();
  return (
    <div className="flex items-center gap-1.5" data-testid="language-switcher">
      <Languages size={14} className="text-muted-foreground" />
      {!compact && <span className="text-xs text-muted-foreground">{t("common.language")}</span>}
      <Select value={locale} onValueChange={setLocale}>
        <SelectTrigger className="h-7 w-[7.5rem] text-xs" data-testid="language-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {supported.map((l) => (
            <SelectItem key={l} value={l} data-testid={`language-option-${l}`}>{LABELS[l] || l}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
